import { BaseService } from '@/modules/Core/services/BaseService'
import type { ISeguimientoDemandaInducida } from '@/modules/DemandaInducida/interfaces/ISeguimientoDemandaInducida'
import type { IDemandaInducidaGenerales } from '@/modules/DemandaInducida/interfaces/IDemandaInducida'
import type { AxiosResponse } from 'axios'
import type {
  IResponseApi,
  IResponseApiSearch
} from '@/modules/Core/interfaces/api/IApis'
import type { IDemandaInducida } from '@/modules/DemandaInducida/interfaces/IDemandaInducida'

export class DemandaInducidaGestionService extends BaseService<IDemandaInducida> {
  constructor() {
    super({ baseUrl: 'induced-demands/gestion' })
  }

  createMultiple(
    demandas: Partial<IDemandaInducida>[]
  ): Promise<AxiosResponse<IResponseApi<IDemandaInducida[]>>> {
    return this.http.post<IResponseApi<IDemandaInducida[]>>(
      '/create-multiple',
      demandas
    )
  }

  createSeguimiento(
    body: ISeguimientoDemandaInducida
  ): Promise<AxiosResponse<IResponseApi<ISeguimientoDemandaInducida>>> {
    return this.http.post<IResponseApi<ISeguimientoDemandaInducida>>(
      '/seguimientos/create',
      body
    )
  }

  updateSeguimiento(
    deinId: number | string,
    body: ISeguimientoDemandaInducida
  ): Promise<AxiosResponse<IResponseApi<ISeguimientoDemandaInducida>>> {
    return this.http.put<IResponseApi<ISeguimientoDemandaInducida>>(
      `/seguimientos/update/${deinId}`,
      body
    )
  }

  getSeguimientosByDemanda(
    deinId: number | string
  ): Promise<AxiosResponse<IResponseApi<ISeguimientoDemandaInducida[]>>> {
    return this.http.get<IResponseApi<ISeguimientoDemandaInducida[]>>(
      `/${deinId}/seguimientos`
    )
  }
  getByPaciente(
    pacienteId: number | string
  ): Promise<AxiosResponse<IResponseApiSearch<IDemandaInducida[]>>> {
    return this.http.get<IResponseApiSearch<IDemandaInducida[]>>(
      `/by-paciente/${pacienteId}`
    )
  }

  deleteSeguimiento(
    sedinId: number | string
  ): Promise<AxiosResponse<IResponseApi<void>>> {
    return this.http.delete<IResponseApi<void>>(
      `/seguimientos/delete/${sedinId}`
    )
  }
  getGenerales(): Promise<
    AxiosResponse<IResponseApi<IDemandaInducidaGenerales>>
  > {
    return this.http.get<IResponseApi<IDemandaInducidaGenerales>>('/generales')
  }
}
